import { render, staticRenderFns } from "./OutputSettings.vue?vue&type=template&id=6ada4984&scoped=true"
import script from "./OutputSettings.vue?vue&type=script&lang=js"
export * from "./OutputSettings.vue?vue&type=script&lang=js"
import style0 from "./OutputSettings.vue?vue&type=style&index=0&id=6ada4984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada4984",
  null
  
)

export default component.exports